import { z } from 'zod';
import { pseBanks } from '@/data/banks';

const rawSchema = z.object({
  name: z.string().optional(),
  documentType: z.enum(['cc', 'ce', 'nit', 'ps']).optional(),
  documentNumber: z.string().optional(),
  email: z.string().optional(),
  phoneNumber: z.string().optional(),
  pseBank: z.enum(pseBanks).optional(),
  puntosColombiaDocumentType: z.enum(['cc', 'ce', 'nit']).optional(),
  puntosColombiaDocumentNumber: z.string().optional(),
});

export type SavedPayerFields = z.infer<typeof rawSchema>;

export function savedPayerStorageKey(merchantId: string): string {
  return `palomma.rentalsPaymentsPortal.payerInfo:v1:${merchantId}`;
}

export function readSavedPayer(merchantId: string): SavedPayerFields | undefined {
  if (typeof window === 'undefined') return undefined;
  try {
    const raw = localStorage.getItem(savedPayerStorageKey(merchantId));
    if (!raw) return undefined;
    const parsed = rawSchema.safeParse(JSON.parse(raw) as unknown);
    return parsed.success ? parsed.data : undefined;
  } catch {
    return undefined;
  }
}

export function writeSavedPayer(merchantId: string, fields: SavedPayerFields): void {
  if (typeof window === 'undefined') return;
  localStorage.setItem(savedPayerStorageKey(merchantId), JSON.stringify(fields));
}

export function clearSavedPayer(merchantId: string): void {
  if (typeof window === 'undefined') return;
  localStorage.removeItem(savedPayerStorageKey(merchantId));
}
